export default __webpack_public_path__ + "static/media/orange-ball.a8a8d2ca.svg";